export default "__VITE_ASSET__Dd3JGNC0__"